interface Props {
  families: { name: string; count: number }[];
  total: number;
  active: string;
  onSelect: (family: string) => void;
  onClear: () => void;
  canClear: boolean;
  showHeading?: boolean;
}

export default function FilterSidebar({ families, total, active, onSelect, onClear, canClear, showHeading = false }: Props) {
  const item = (name: string, label: string, count: number) => {
    const on = active === name;
    return (
      <li key={name}>
        <button
          type="button"
          aria-pressed={on}
          onClick={() => onSelect(name)}
          className={`w-full flex items-center justify-between gap-3 py-2.5 text-left text-sm cursor-pointer whitespace-nowrap transition-colors focus-visible:outline-none focus-visible:underline ${on ? 'text-primary-500 font-medium' : 'text-foreground-700 hover:text-foreground-950'}`}
        >
          <span>{label}</span>
          <span className="font-label text-[11px] text-foreground-400 tabular-nums">{count}</span>
        </button>
      </li>
    );
  };

  return (
    <nav aria-label="Product categories">
      {showHeading && <p className="eyebrow !text-[11px] text-foreground-500 mb-3">Categories</p>}
      <ul className="-mt-2.5">
        {item('all', 'All Products', total)}
        {families.map((f) => item(f.name, f.name, f.count))}
      </ul>
      <button
        type="button"
        onClick={onClear}
        disabled={!canClear}
        className="mt-6 inline-flex items-center gap-2 font-label text-xs tracking-[0.08em] uppercase whitespace-nowrap cursor-pointer text-foreground-950 hover:text-primary-500 disabled:text-foreground-300 disabled:cursor-default transition-colors"
      >
        <i className="ri-close-line" /> Clear filters
      </button>
    </nav>
  );
}